import React, {useState, useEffect} from 'react'
import {Button, Row, Col, ListGroup, Image, Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { PayPalButton } from "react-paypal-button-v2";
import {useDispatch, useSelector} from 'react-redux'
import  Message from '../components/Message'
import  Loader from '../components/Loader'
import CheckoutSteps from '../components/CheckoutSteps'
import { createOrder, payOrder } from '../actions/orderActions'
import { ORDER_CREATE_RESET, ORDER_PAY_RESET } from '../constants/orderConstants'
import { Helmet } from 'react-helmet-async'


function PlaceOrderScreen({history}) {

  const [sdkReady, setSdkReady] = useState(false)
  // Tiene il risultato del pagamento PayPal finché l'ordine non è stato
  // creato: l'ordine nasce SOLO dopo che il pagamento è andato a buon
  // fine, mai prima — così non restano ordini "fantasma" mai pagati.
  const [pendingPaymentResult, setPendingPaymentResult] = useState(null)

  const orderCreate = useSelector(state => state.orderCreate)
  const { order, error, success } = orderCreate

  const orderPay = useSelector(state => state.orderPay)
  const { loading: loadingPay, success: successPay } = orderPay

  const dispatch = useDispatch();
  const cart = useSelector(state => state.cart)

  cart.itemsPrice = cart.cartItems.reduce((acc, item) =>  acc + item.price * item.qty, 0).toFixed(2)
  cart.shippingPrice = 0
  cart.taxPrice = 0

  cart.totalPrice = (Number(cart.itemsPrice) + Number(cart.shippingPrice) + Number(cart.taxPrice)).toFixed(2)

  if(!cart.paymentMethod){
    history.push('/payment')
  }

  const addPayPalScript = () => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = `https://www.paypal.com/sdk/js?client-id=${process.env.REACT_APP_PAYPAL_CLIENT_ID}&currency=EUR`
    script.async = true
    script.onload = () => {
        setSdkReady(true)
    }
    document.body.appendChild(script)
  }

  useEffect(() => {
    if (!window.paypal) {
        addPayPalScript()
    } else {
        setSdkReady(true)
    }
  }, [])

  // Step 1: il pagamento PayPal va a buon fine -> SOLO ORA creiamo l'ordine.
  const paymentSuccessHandler = (paymentResult) => {
    setPendingPaymentResult(paymentResult)
    dispatch(createOrder({
        orderItems: cart.cartItems,
        shippingAddress: cart.shippingAddress,
        paymentMethod: cart.paymentMethod,
        itemsPrice: cart.itemsPrice,
        shippingPrice: cart.shippingPrice,
        taxPrice: cart.taxPrice,
        totalPrice: cart.totalPrice,
    }))
  }

  // Step 2: l'ordine è stato creato -> lo segniamo subito come pagato,
  // usando il risultato PayPal che avevamo tenuto da parte.
  useEffect(() => {
    if (success && order && pendingPaymentResult) {
        dispatch(payOrder(order._id, pendingPaymentResult))
    }
  }, [success, order, pendingPaymentResult, dispatch])

  // Step 3: pagamento confermato sull'ordine -> reindirizza e pulisci lo stato.
  useEffect(() => {
    if (successPay && order) {
        dispatch({ type: ORDER_CREATE_RESET })
        dispatch({ type: ORDER_PAY_RESET })
        history.push(`/order/${order._id}`)
    }
  }, [successPay, order, dispatch, history])

  return (
    <div>
         <Helmet>
           <meta name="robots" content="noindex, follow" />
         </Helmet>
        <CheckoutSteps step1 step2 step3 step4/>
       <Row>
        <Col md={8}>
            <ListGroup variant='flush'>
                <ListGroup.Item>
                    <h2>Spedizione</h2>

                    <p>
                        <strong>Indirizzo: </strong>
                        {cart.shippingAddress.address}, {cart.shippingAddress.city}
                        {'  '}
                        {cart.shippingAddress.postalCode},
                        {'  '}
                        {cart.shippingAddress.country}
                    </p>
                </ListGroup.Item>

                <ListGroup.Item>
                    <h2>Metodo di pagamento</h2>
                    <p>
                        <strong>Provider: </strong>
                        {cart.paymentMethod}
                    </p>
                </ListGroup.Item>

                <ListGroup.Item>
                    <h2>Elenco ordine</h2>
                    {cart.cartItems.length === 0 ? <Message variant='info'>
                        Your cart is empty
                    </Message> : (
                        <ListGroup variant='flush'>
                            {cart.cartItems.map((item, index) => (
                                <ListGroup.Item key={index}>
                                        <Row>
                                            <Col md={1}>
                                                <Image src={item.image} alt={item.name} fluid rounded/>
                                            </Col>
                                            <Col>
                                                <Link to={`/product/${item.product}`}>{item.name}</Link>
                                            </Col>
                                            <Col md={4}>
                                                {item.qty} X €{item.price} = €{(item.qty * item.price).toFixed(2)}
                                            </Col>
                                        </Row>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    )}
                </ListGroup.Item>
            </ListGroup>

        
        </Col>

        <Col md={4}>
            <Card>
                <ListGroup variant='flush'>
                    <ListGroup.Item>
                        <h2>Sommario</h2>
                    </ListGroup.Item>

                    <ListGroup.Item>
                        <Row>
                            <Col>Oggetti:</Col>
                            <Col>€{cart.itemsPrice}</Col>
                        </Row>
                    </ListGroup.Item>

                    <ListGroup.Item>
                        <Row>
                            <Col>Spedizione:</Col>
                            <Col>€{cart.shippingPrice}</Col>
                        </Row>
                    </ListGroup.Item>

                    <ListGroup.Item>
                        <Row>
                            <Col>Totale:</Col>
                            <Col>€{cart.totalPrice}</Col>
                        </Row>
                    </ListGroup.Item>

                    <ListGroup.Item>
                        {error && <Message variant='danger'>{error}</Message>}
                    </ListGroup.Item>

                    <ListGroup.Item>
                        {(pendingPaymentResult && (success || loadingPay)) ? (
                            <Loader/>
                        ) : !sdkReady ? (
                            <Loader/>
                        ) : cart.cartItems.length === 0 ? (
                            <Message variant='info'>Il carrello è vuoto</Message>
                        ) : (
                            <div className="p-3 rounded" style={{ backgroundColor: '#ffffff' }}>
                                <PayPalButton
                                    amount={cart.totalPrice}
                                    currency="EUR"
                                    onSuccess={paymentSuccessHandler}
                                ></PayPalButton>
                            </div>
                        )}
                    </ListGroup.Item>

                </ListGroup>
            </Card>
        </Col>
       </Row>
    </div>
  )
}

export default PlaceOrderScreen